var map = {
	"./17 Live.svg": "pNnB",
	"./Asoview.svg": "84Ml",
	"./Premium Bandai.svg": "w6ar",
	"./SHEIN.svg": "YOrV",
	"./agoda.svg": "iHBV",
	"./amazon.svg": "hNO/",
	"./biccamera.svg": "xvav",
	"./buyma.svg": "Vrt2",
	"./deanndeluca.svg": "Hi/l",
	"./dmm.svg": "POQi",
	"./gladd.svg": "hUGz",
	"./hololive.svg": "VWlt",
	"./magaseek.svg": "s+AS",
	"./morecontact.svg": "ytYX",
	"./qoo10.svg": "oU4T",
	"./rakuma.svg": "gUOX",
	"./shoplist.svg": "49M/",
	"./spacemarket.svg": "km2T",
	"./willer.svg": "uadZ",
	"./yamada.svg": "I744"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wRQo";